import { InAppNotificationService } from "./in-app-notification.service.js";

/**
 * Shared Helper for Triggering System Notifications
 * Centralizes the message templates and logic
 */
export const NotificationTriggerService = {
    /**
     * Notify user when their content/request is received
     */
    notifyReceipt: async (userId, type) => {
        const title = `${type}이(가) 접수되었습니다.`;
        const msg = "꼼꼼히 검토 후 빠르게 답변 드리겠습니다.";
        await InAppNotificationService.createNotification(userId, 'system', title, msg, null);
    },

    /**
     * Notify user when they are approved as author
     */
    notifyAuthorApproved: async (userId) => {
        await InAppNotificationService.createNotification(
            userId,
            'system',
            '작가 신청이 승인되었습니다! 🎉 - 이제 스튜디오에서 작품을 자유롭게 연재하실 수 있습니다.',
            null,
            '/studio'
        );
    },

    /**
     * Notify user when they are rejected as author
     */
    notifyAuthorRejected: async (userId) => {
        await InAppNotificationService.createNotification(
            userId,
            'system',
            '작가 신청이 반려되었습니다. - 신청 내용을 보완하여 다시 도전해주세요.',
            null,
            null
        );
    },

    /**
     * Notify author when their series is published
     */
    notifySeriesPublished: async (authorId, seriesTitle, seriesId) => {
        await InAppNotificationService.createNotification(
            authorId,
            'system',
            `작품이 발행되었습니다: ${seriesTitle}. 독자들에게 공개되었습니다.`, // Combined Message
            null, // fromUser (System)
            `/series/${seriesId}`
        );
    },

    /**
     * Notify user when their support ticket is replied to
     */
    notifySupportReply: async (userId, ticketContentShort) => {
        // Truncate ticket content for context
        const context = ticketContentShort.length > 20 ? ticketContentShort.substring(0, 20) + "..." : ticketContentShort;
        await InAppNotificationService.createNotification(
            userId,
            'system',
            '문의하신 내용에 답변이 등록되었습니다.',
            `문의: "${context}"`,
            null // Opens Support Modal automatically? Not easily linkable yet without deep link or global event.
            // PWA Manager could handle this if we add a 'action: open_support' field later. For now simple notif.
        );
    }
};
